import React from 'react';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';

type CameraControlsProps = {
  channel: IDeviceChannel;
  isListItem?: boolean;
};

const CameraControls: React.FC<CameraControlsProps> = () => {
  return null;
};

export default CameraControls;
